<template>
	<div>
		<case-form :schema="schema" />
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"

export default {
	name: "JBProposalSumInsured",
	components: { CaseForm },
	data() {
		return {
			schema: [
				{
					component: "html",
					props: {
						content:
							"<div class='fs4 fw7 lh125'>22. For what amount is Policy required?</div>"
					},
					bindTo: ""
				},
				{
					label: "(a) On stock (including goods in trust and bank notes)",
					component: "text",
					dataType: "string",
					bindTo: "case.facts.stockSumInsuredAmount"
				},
				{
					label: "(b) On trade, office furniture, etc.",
					component: "text",
					dataType: "string",
					bindTo: "case.facts.tradeOfficeFurnitureSumInsuredAmount"
				}
			]
		}
	}
}
</script>
